
import Layers from "slotworks/graphics/layers/layers";

export function HideAllMenusCommand() {
    Layers.Menus.hide();
    Layers.MenusContent.hide();
    Layers.PaytableContent.hide();
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/menus/hide-all-menus-command.ts